import React from 'react';

import { ReactComponent as DeleteIcon } from '@assets/icons/delete.svg';
import { Button } from '@atoms';
import { showDeleteConfirm } from '@utils/modal';

import s from './styles.module.less';

export const DeleteButton = ({ onDelete, title, subtitle, ...props }) => (
  <Button
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    className={s.deleteButton}
    type="link"
    icon={<DeleteIcon />}
    onClick={(e) => {
      e.stopPropagation();
      showDeleteConfirm({ onOk: onDelete, title, content: subtitle });
    }}
  />
);

export default DeleteButton;
